import axios from 'axios';
import AxiosBase from '@/auth/axiosBase';
export default class MenuService extends AxiosBase {
  constructor() {
    super();
  }

  async GetMenuListByRoleId () {
    let result = {};
    const url = `${process.env.VUE_APP_BACKEND_URL}/api/Menu/GetMenuListByRoleId`;
   
    await axios.get(url)
      .then((response) => {
        result = response;
      }).catch((error) => {
        console.log(error);
      });
    return result;
  }
 
 async  GetUnacsMenuListByRoleId  () {
    let result = {};
    const url = `${process.env.VUE_APP_BACKEND_URL}/api/Menu/GetUnacsMenuListByRoleId`;
    await axios.get(url)
      .then((response) => {
        result = response;
      }).catch((error) => {
        console.log(error);
      });
    return result;
  }

  async GetMenuListByAuthType() {
    let result = {};
    const url = `${process.env.VUE_APP_BACKEND_URL}/api/Menu/GetMenuListByAuthType`;
    await axios.get(url)
      .then((response) => {
        result = response;
      }).catch((error) => {
        console.log(error);
      });
    return result;
  }

}
